import { render, staticRenderFns } from "./UserSignaturesSig.vue?vue&type=template&id=e4c2f4f0&scoped=true"
import script from "./UserSignaturesSig.vue?vue&type=script&lang=js"
export * from "./UserSignaturesSig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4c2f4f0",
  null
  
)

export default component.exports